import Link from "next/link";
import Image from "next/image";

import { newFlashPCBLogo } from "../../constants/images";
import { HOMEPAGE } from "../../constants/routes";
import * as styledElements from "./HeaderStyles";

const LogoLink = ({ onClick }: { onClick?: () => void }) => (
  <Link href={HOMEPAGE} passHref={true}>
    <styledElements.StyledLink onClick={onClick}>
      <Image
        src={newFlashPCBLogo}
        alt="FlashPCB logo"
        width="226"
        height="30"
      />
    </styledElements.StyledLink>
  </Link>
);

export default LogoLink;
